import { ForgotPasswordForm, ResetPasswordForm } from '@/types/password';
import { Response } from '@/types/response';
import { api, getCsrfToken } from '@/utils/axios';

export const resetPassword = async (
  data: ResetPasswordForm,
): Promise<Response> => {
  await getCsrfToken();
  const response = await api.post('/app-web/auth/reset-password', data);
  return response.data;
};

export const forgotPassword = async (
  data: ForgotPasswordForm,
): Promise<Response> => {
  await getCsrfToken();
  const response = await api.post('/app-web/auth/forgot-password', data);
  return response.data;
};
